module.exports = __webpack_public_path__ + "img/PeterInverso.61d91a24.jpg";